import { render } from "./AccountTable.vue?vue&type=template&id=1c80d96a&scoped=true"
import script from "./AccountTable.vue?vue&type=script&lang=js"
export * from "./AccountTable.vue?vue&type=script&lang=js"

import "./AccountTable.vue?vue&type=style&index=0&id=1c80d96a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c80d96a"]])

export default __exports__